// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-block[data-v-5861012e]{border-bottom-left-radius:25px;border-bottom-right-radius:25px;height:30px;left:50%;position:fixed;text-align:center;top:0;transform:translate(-50%)}a.navbar-item[data-v-5861012e]{font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
